function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 24V2a1 1 0 10-2 0v5H2a1 1 0 000 2h4v15a2 2 0 002 2h15v4a1 1 0 102 0v-4h5a1 1 0 100-2H8z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 7a1 1 0 100 2h12v12a1 1 0 102 0V9a2 2 0 00-2-2H11z",
  fill: "currentColor"
})));